import React, { useState } from "react";
import { apiRequest } from "../apiService/allApi";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";

function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // 🔹 SIGNUP API (Verify Email)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestData = {
      name: name,
      email: email,
      password: password,
    };

    try {
      setLoading(true);

      const response = await apiRequest(
        "api/customer/verify-email",
        "POST",
        requestData
      );

     // ✅ SUCCESS
Swal.fire({
  icon: "success",
  title: "Success",
  text:
    response?.data?.message ||
    "Please check your email to verify your account",
}).then(() => {
  // 🔹 FORM RESET
  setName("");
  setEmail("");
  setPassword("");
});
    } catch (e) {
      // console.log(e);

      // ❌ ERROR
      Swal.fire({
        icon: "error",
        title: "Error",
        text: e?.response?.data?.message || "Signup failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-4">
          <div className="auth-box">
            <h2>Signup</h2>
            <hr />

            <div className="text-center authbox-1">
              <h6>Welcome</h6>
              <p>Enter your details to create account</p>
            </div>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />

              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <div className="d-flex justify-content-center">
                <button
                  className="common_blackButton__CWUUs"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Please wait..." : "Signup"}
                </button>
              </div>
            </form>

            <div className="auth-link mt-2">
              <Link to="/login">Already have an account?</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
